import { z } from "zod"

import { CONST } from "@/constants"
import { UseCustomerTranslationsType } from "../SchemaUtils"
import { isAfter } from "date-fns"

export type CustomerProfileSchema = z.infer<ReturnType<typeof CustomerProfileSchemas.create>>
export type CustomerProfileUpdateSchema = z.infer<ReturnType<typeof CustomerProfileSchemas.update>>

export class CustomerProfileSchemas {
  static create(t: UseCustomerTranslationsType) {
    return z.object({
      fullName: z
        .string({ message: t("profile.errors.fullName.required") })
        .min(1, t("profile.errors.fullName.required"))
        .max(40, t("profile.errors.fullName.maxLength")),
      birthDate: z
        .string({ message: t("profile.errors.birthdate.required") })
        .datetime()
        .refine((date) => {
          const birthDate = new Date(date)
          const minAge = CONST.MIN_AGE
          const age = new Date().getFullYear() - birthDate.getFullYear()
          const monthDiff = new Date().getMonth() - birthDate.getMonth()
          const finalAge =
            monthDiff < 0 || (monthDiff === 0 && new Date().getDate() < birthDate.getDate()) ? age - 1 : age

          return finalAge >= minAge
        }, t("profile.errors.birthdate.ageRestrictionMin"))
        .refine((date) => {
          const birthDate = new Date(date)
          const maxBirthdate = new Date(CONST.START_BIRTHDATE)
          return isAfter(birthDate, maxBirthdate)
        }, t("profile.errors.birthdate.ageRestrictionMax")),
    })
  }

  static update(t: UseCustomerTranslationsType) {
    return CustomerProfileSchemas.create(t).partial()
  }
}
